<template>
  <div class="es">
    <div class="es__art"><v-icon size="40" color="primary">{{ entity === 'lead' ? 'mdi-account-search-outline' : 'mdi-briefcase-search-outline' }}</v-icon></div>
    <div class="es__title">{{ entity === 'lead' ? $t('crmEmptyLeads') : $t('crmEmptyDeals') }}</div>
    <div class="es__sub">{{ entity === 'lead' ? $t('crmEmptyLeadsHint') : $t('crmEmptyDealsHint') }}</div>
    <v-btn depressed color="primary" small class="es__btn" @click="$emit('create')">
      <v-icon small class="me-1">mdi-plus</v-icon>{{ entity === 'lead' ? $t('crmNewLead') : $t('crmNewDeal') }}
    </v-btn>
  </div>
</template>

<script>
export default { name: 'CrmEmptyState', props: { entity: { type: String, default: 'lead' } } }
</script>

<style scoped>
.es { display: flex; flex-direction: column; align-items: center; text-align: center; padding: 48px 16px; gap: 6px; }
.es__art { width: 84px; height: 84px; border-radius: 50%; background: rgba(25, 118, 210, .08); display: flex; align-items: center; justify-content: center; margin-bottom: 8px; }
.es__title { font-weight: 700; font-size: 1rem; }
.es__sub { font-size: .82rem; opacity: .6; max-width: 360px; }
.es__btn { margin-top: 10px; border-radius: 6px !important; }
</style>
